import { ThemeProvider } from "@constellation-academy/epic-ui";
import { TkComponentsContext } from "@constellation-academy/framework-react-components";
import * as Sentry from "@sentry/react";
import { type APIOptions as PrimeReactAPIOptions, PrimeReactProvider } from "primereact/api";
import { Suspense } from "react";
import { RelayEnvironmentProvider } from "react-relay";
import { ToastContainer } from "react-toastify";
import { ErrorFallbackComponent } from "./components/error-fallback/error-fallback.component";
import { Loader } from "./components/Loader";
import { TkaAdminTheme } from "./core-style/component-theme/component-theme";
import { PermissionBasedNavigation } from "./navigation/permission-based-navigation.component";
import { RelayEnvironment } from "./RelayEnvironment";
import { LightTheme } from "./themes/light-theme";

const primeReactContextValue = {
	zIndex: {
		modal: 500,
		overlay: 3000,
		menu: 3000,
		tooltip: 3100,
		toast: 5200,
	},
} satisfies Partial<PrimeReactAPIOptions>;

function App() {
	return (
		<TkComponentsContext.Provider value={TkaAdminTheme}>
			<ThemeProvider theme={LightTheme}>
				<ToastContainer autoClose={5000} newestOnTop={true} />
				<Sentry.ErrorBoundary fallback={<ErrorFallbackComponent />}>
					<RelayEnvironmentProvider environment={RelayEnvironment}>
						<PrimeReactProvider value={primeReactContextValue}>
							<Suspense fallback={<Loader />}>
								<PermissionBasedNavigation />
							</Suspense>
						</PrimeReactProvider>
					</RelayEnvironmentProvider>
				</Sentry.ErrorBoundary>
			</ThemeProvider>
		</TkComponentsContext.Provider>
	);
}

export default App;
